{
  "page_count": "av {n, plural, one{# side} other{# sider}}"
}
